import * as actionTypes from '../actions/actionTypes';
import { updateObject } from './../../../../shared/utils';

const initialState = {
  selectedFilesInfo: null,
  error: null,
  selectedFilesInfoLoading: false,

  sendPolicyPackageInfo: null,
  sendPolicyPackageInfoError: null,
  sendPolicyPackageInfoLoading: false,

  certificateFiles: null,
  certificateFilesError: null,
  certificateFilesLoading: false,
};

const getFilesInfoStart = (state, action) => {
  return updateObject(state, {
    selectedFilesInfo: null,
    error: null,
    selectedFilesInfoLoading: true,
  });
};

const getFilesInfoSuccess = (state, action) => {
  return updateObject(state, {
    selectedFilesInfo: action.selectedFilesInfo,
    error: null,
    selectedFilesInfoLoading: false,
  });
};

const getFilesInfoFail = (state, action) => {
  return updateObject(state, {
    selectedFilesInfo: null,
    error: action.error,
    selectedFilesInfoLoading: false,
  });
};

const getSendPolicyPackageInfoStart = (state, action) => {
  return updateObject(state, {
    sendPolicyPackageInfo: null,
    sendPolicyPackageInfoError: null,
    sendPolicyPackageInfoLoading: true,
  });
};

const getSendPolicyPackageInfoSuccess = (state, action) => {
  return updateObject(state, {
    sendPolicyPackageInfo: action.data,
    sendPolicyPackageInfoError: null,
    sendPolicyPackageInfoLoading: false,
  });
};

const getSendPolicyPackageInfoFail = (state, action) => {
  return updateObject(state, {
    sendPolicyPackageInfo: null,
    sendPolicyPackageInfoError: action.error,
    sendPolicyPackageInfoLoading: false,
  });
};

const sendCertificateFilesStart = (state, action) => {
  return updateObject(state, {
    certificateFiles: null,
    certificateFilesError: null,
    certificateFilesLoading: true,
  });
};

const sendCertificateFilesSuccess = (state, action) => {
  return updateObject(state, {
    certificateFiles: null,
    certificateFilesError: action.data,
    certificateFilesLoading: false,
  });
};

const sendCertificateFilesFail = (state, action) => {
  return updateObject(state, {
    certificateFiles: null,
    certificateFilesError: action.error,
    certificateFilesLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_FILES_INFO:
      return getFilesInfoStart(state, action);
    case actionTypes.GET_FILES_INFO_SUCCESS:
      return getFilesInfoSuccess(state, action);
    case actionTypes.GET_FILES_INFO_FAIL:
      return getFilesInfoFail(state, action);

    case actionTypes.SEND_FILES_GET_SEND_POLICY_PACKAGE_INFO_START:
      return getSendPolicyPackageInfoStart(state, action);
    case actionTypes.SEND_FILES_GET_SEND_POLICY_PACKAGE_INFO_SUCCESS:
      return getSendPolicyPackageInfoSuccess(state, action);
    case actionTypes.SEND_FILES_GET_SEND_POLICY_PACKAGE_INFO_FAIL:
      return getSendPolicyPackageInfoFail(state, action);

    case actionTypes.SEND_CERTIFICATE_FILES_START:
      return sendCertificateFilesStart(state, action);
    case actionTypes.SEND_CERTIFICATE_FILES_SUCCESS:
      return sendCertificateFilesSuccess(state, action);
    case actionTypes.SEND_CERTIFICATE_FILES_FAIL:
      return sendCertificateFilesFail(state, action);

    default:
      return state;
  }
};

export default reducer;
